import _ from 'lodash';

import { makeReducer } from '../../base/reducer';
import { reducer as authReducer } from '../auth/actions';
import { emptyFilter, toggleInList } from './filterUtils';

// The feature is switched on per organisation through
// log_organisation.ui_info.routeFilter (same place as customForms etc.).
export
const isRouteFilterEnabled = (state) => Boolean(_.get(state, `${authReducer.name}.user.ui_info.routeFilter`));

// The selection (manifestId + days + courierIds) is persisted to localStorage
// through the reducer's `store`, so it survives a page reload. Option lists
// are runtime-only: they are re-collected each time waybills are loaded.
const init = {
  manifestId: null,
  days: [],
  courierIds: [],
  availableDays: [],
  availableCouriers: [],
};

export const reducer = makeReducer('routeFilter', init);

const persist = (store, state) => {
  const persisted = {
    manifestId: state.manifestId,
    days: state.days,
    courierIds: state.courierIds,
  };
  store(persisted);
  return persisted;
};

export const actions = {
  'setAvailable': reducer.makeAction(
    (manifestId, days, couriers) => ({ manifestId, days, couriers }),
    (state, action, store) => {
      const sameManifest = state.manifestId === action.manifestId;
      const newState = {
        manifestId: action.manifestId,
        availableDays: action.days || [],
        availableCouriers: action.couriers || [],
        days: sameManifest ? state.days : [],
        courierIds: sameManifest ? state.courierIds : [],
      };
      persist(store, newState);
      return newState;
    },
    'SET_AVAILABLE'
  ),

  'toggleDay': reducer.makeAction(
    (day) => ({ day }),
    (state, action, store) => persist(store, { ...state, days: toggleInList(state.days, action.day) }),
    'TOGGLE_DAY'
  ),

  'setDays': reducer.makeAction(
    (days) => ({ days }),
    (state, action, store) => persist(store, { ...state, days: [...(action.days || [])] }),
    'SET_DAYS'
  ),

  'toggleCourier': reducer.makeAction(
    (courierId) => ({ courierId }),
    (state, action, store) => persist(store, {
      ...state,
      courierIds: toggleInList(state.courierIds, Number(action.courierId)),
    }),
    'TOGGLE_COURIER'
  ),

  'setCouriers': reducer.makeAction(
    (courierIds) => ({ courierIds }),
    (state, action, store) => persist(store, {
      ...state,
      courierIds: (action.courierIds || []).map(Number),
    }),
    'SET_COURIERS'
  ),

  'reset': reducer.makeAction(
    null,
    (state, action, store) => persist(store, { ...state, ...emptyFilter }),
    'RESET'
  ),
};

export const selectFilter = (state) => ({
  days: state[reducer.name].days,
  courierIds: state[reducer.name].courierIds,
});

// Effective filter for data consumers: the persisted selection when the
// feature is enabled for this organisation, otherwise nothing is filtered.
// Returns stable references so connected components do not re-render idly.
export const selectActiveFilter = (state) => (isRouteFilterEnabled(state)
  ? state[reducer.name]
  : emptyFilter);
